import { EquipmentType } from "@/Models/Enums/EquipmentType";
import { createContext } from "react";

export const EquipmentTypeContext = createContext<EquipmentType>(null as any);